import * as React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import { Input } from "components/bootstrap";
import { Col, Row, Badge } from "common/components";
import { useSelectedRows, useSelectedRowsDispatch } from "common/contexts";
import { requiredLicenseMessage } from "illuminate/components/content-hub/utils";
const InputWrapper = styled.div`
  & > .form-group {
    margin: 0;
  }
`;
function DependsOrRequiredBy({ packs, dependencies = false }) {
  const selectedPacks = useSelectedRows();
  const selectedPacksDispatch = useSelectedRowsDispatch();
  const isSelected = useCallback(
    (pack) => !!selectedPacks.find((sPack) => pack.pack_id === sPack.pack_id),
    [selectedPacks]
  );
  const onClick = (pack) => (e) => {
    if (e.target.checked) {
      selectedPacksDispatch({ type: "add", payload: [pack], key: "pack_id" });
    } else {
      selectedPacksDispatch({ type: "remove", payload: [pack], key: "pack_id" });
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, packs.length > 0 && /* @__PURE__ */ React.createElement(Col, { $gap: "xs" }, /* @__PURE__ */ React.createElement("strong", null, dependencies ? "Dependencies" : "Required by", ":"), packs.map((rPack) => /* @__PURE__ */ React.createElement(Row, { key: `${dependencies ? "depends-on" : "required-by"}-${rPack.pack_id}`, $align: "center", $gap: "xs" }, /* @__PURE__ */ React.createElement(InputWrapper, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `${dependencies ? "depends-on" : "required-by"}-${rPack.pack_id}`,
      type: "checkbox",
      name: `${dependencies ? "depends-on" : "required-by"}-${rPack.pack_id}`,
      checked: isSelected(rPack),
      value: isSelected(rPack),
      onClick: onClick(rPack),
      disabled: !(rPack.is_compatible && rPack.included_in_bundle)
    }
  )), /* @__PURE__ */ React.createElement("span", null, rPack.title), /* @__PURE__ */ React.createElement(Badge, { variant: rPack.enabled ? "success" : "danger" }, rPack.enabled ? "enabled" : "not enabled"), !rPack.included_in_bundle && /* @__PURE__ */ React.createElement(Badge, { variant: "danger" }, requiredLicenseMessage(rPack.license))))));
}
export default DependsOrRequiredBy;
